// extracted by mini-css-extract-plugin
module.exports = {"PopUpFullModal":"FullModal_PopUpFullModal__1ro7R"};